import React from "react";

export type QuickAccessItem = {
  name: string;
  desc: string;
  link: string;
};

type QuickAccessProps = {
  items: QuickAccessItem[];
};

export default function QuickAccess({ items }: QuickAccessProps) {
  return (
    <div className="row g-3">
      {items.map((item, i) => (
        <div className="col-12 col-md-6 col-lg-4 p-3" key={i}>
          <div className="card h-100 border-0">
            <a
              href={item.link}
              className="h-100 text-decoration-none"
              style={{ color: "inherit" }}
            >
              <div
                className="card-body d-flex flex-row justify-content-between align-items-center"
                style={{ padding: "15px", minHeight: "78px" }}
              >
                <div>
                  <h6 style={{fontSize: "15px"}} className="fw-bold mb-1">{item.name}</h6>
                  <p style={{fontSize: "12px"}} className="mb-0">{item.desc}</p>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                >
                  <g clipPath="url(#clip0_158_1721)">
                    <path
                      d="M11.775 7.50001C11.775 7.76884 11.6724 8.03764 11.4675 8.24259L5.0178 14.6923C4.60752 15.1025 3.94231 15.1025 3.5322 14.6923C3.12208 14.2821 3.12208 13.6171 3.5322 13.2068L9.23927 7.50001L3.5324 1.79323C3.12228 1.38295 3.12228 0.717946 3.5324 0.307862C3.94251 -0.102619 4.60772 -0.102619 5.018 0.307862L11.4677 6.75742C11.6726 6.96248 11.775 7.23128 11.775 7.50001Z"
                      fill="#2A3E50"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_158_1721">
                      <rect
                        width="15"
                        height="15"
                        fill="white"
                        transform="translate(0 15) rotate(-90)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </a>
          </div>
        </div>
      ))}
    </div>
  );
}

